<template>
  <div v-if="question && answer">
    <button class="w-full" @click="toggle()">
      <h3 class="flex items-center px-6 sm:px-8 py-4 font-bold border-t-2 border-app-green-100 cursor-pointer lg:px-10 md:text-lg">
        <span class="text-left flex-auto font-semibold" v-html="question" />
        <AtomIconChevronDown class="shrink-0 ml-2 w-5 h-5 text-app-green transition duration-200 ease-in-out" :class="{ 'flipped-upsidedown': open }" />
      </h3>
    </button>
    <SmoothReflow class="bg-app-green-100 overflow-hidden transition-all duration-500 ease-in-out">
      <div :class="{ 'h-auto': open, 'h-0': !open }">
        <div class="p-6 sm:p-8 lg:px-10" :class="{ block: open, hidden: !open }">
          <div class="prose prose--app max-w-none" v-html="answer" />
        </div>
      </div>
    </SmoothReflow>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  question: string
  answer: string
}

defineProps<Props>()

const open = ref(false)
function toggle() {
  open.value = !open.value
}
</script>

<style lang="scss" scoped>
.flipped-upsidedown {
  transform: rotate(180deg);
}
</style>
